//common
import './common';


document.addEventListener('DOMContentLoaded', () => {
    const viewportVideos = document.querySelectorAll('._viola-dip video._play-in-viewport');
    const lazyVideos = document.querySelectorAll('._viola-dip video._lazy');

    const options = {
        threshold: 0.9
    };

    const playInViewportObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const video = entry.target;
            if (!video.classList.contains('_play-in-viewport') || matchMedia('(min-width: 1200px)').matches) return;

            if (entry.isIntersecting) {
                video.play();
            } else {
                video.pause();
                video.currentTime = 0;
            }
        });
    }, options);

    const lazyLoadObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
                if (video.classList.contains('_lazy')) {
                    video.src = video.dataset.src;
                }
                video.load();
                video.classList.remove('_lazy');
                lazyLoadObserver.unobserve(video);
            }
        });
    });

    lazyVideos.forEach(video => lazyLoadObserver.observe(video));
    viewportVideos.forEach(video => {
        playInViewportObserver.observe(video);
        if (video.classList.contains('_play-in-viewport')) {
            video.addEventListener('mouseenter', ({ target: video }) => {
                video.play()
            });
            video.addEventListener('mouseleave', ({ target: video }) => {
                video.pause();
                video.currentTime = 0;
            })
        }
    });
});
